import {css, StyleSheet} from 'aphrodite';
import React, {useMemo} from 'react';

import AnalysisRunningAnimation from 'analysis-tool/ui/components/AnalysisRunningAnimation';
import {FONT_PROXIMA_16} from 'styles/FontConstants';
import {NEAR_BLACK} from 'ui-library/Colors';

import DataViewContext, {useDataViewContext} from './DataViewContext';
import DataViewPane from './DataViewPane';

/**
 * Render view for running views.
 *
 * @package
 */
export default function RunningView(): JSX.Element {
  const dataViewContextValue = useDataViewContext();
  const newDataViewContextValue = useMemo(
    () => ({
      ...dataViewContextValue,
      dataTestAttrs: {component: 'RunningView', element: 'root'},
    }),
    [dataViewContextValue]
  );

  return (
    <DataViewContext.Provider value={newDataViewContextValue}>
      <DataViewPane>
        <div className={css(styles.runningViewWrapper)}>
          <div className={css(styles.runningAnimationWrapper)}>
            <AnalysisRunningAnimation />
          </div>
          <p className={css(styles.titleText)}>Running view</p>
        </div>
      </DataViewPane>
    </DataViewContext.Provider>
  );
}

const styles = StyleSheet.create({
  runningAnimationWrapper: {
    marginBottom: 20,
  },
  runningViewWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
  titleText: {
    ...FONT_PROXIMA_16,
    color: NEAR_BLACK,
  },
});
